import type { NPCConfig } from '@/entities';
// import {StoryManager} from "@/systems";

const config: NPCConfig[] = [
  {
    x: 2480,
    y: 1860,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/gate_close.png',
    dialogTree: {
      startDialogId: 'toilet_1',
      nodes: {
        toilet_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Pintu ini sepertinya terkunci',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "toilet_2"
        },
        toilet_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Kira-kira mengarah kemana pintu ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1500,
    y: 1300,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    interactOnce : true,
    scale : 0.3,
    hideOnState : ["BEAR_RETRIEVED"],
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'bear_1',
      nodes: {
        bear_1: {
          id: 'bear_1',
          speaker: 'Yan',
          text: 'Apa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bear_2",
          storyAction: { type: 'addState', value: "BEAR_RETRIEVED" },
          itemReward: { itemId: 'teddy_bear', quantity: 1},
        },
        bear_2: {
          id: 'toilet_1',
          speaker: '',
          text: 'Yan mendapatkan boneka beruang!',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bear_3",
        },
        bear_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Boneka milik siapa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "bear_4",
        },
        bear_4: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Jika tidak ada yang punya, bisa ku berikan ke Diana!',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1000,
    y: 1230,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    scale : 1.5,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'exit_1',
      triggerOnCollision: true,
      nodes: {
        exit_1: {
          id: 'bear_1',
          speaker: 'Yan',
          text: 'Ini adalah gerbang keluar dari desa',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "exit_2",
        },
        exit_2: {
          id: 'bear_1',
          speaker: 'Yan',
          text: 'Belum saatnya aku kembali ke kota',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 1570,
    y: 1530,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'toilet_1',
      nodes: {
        toilet_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ini adalah toilet umum.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "toilet_2"
        },
        toilet_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Belum perlu ke toilet sekarang.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2400,
    y: 750,
    name: 'Romo Darius',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_darius.png', // Use NPC image
    repeatable : true,
    dialogTree: {
      startDialogId: 'romo_part2_1',
      nodes: {
        romo_part2_1: {
          id: 'romo_part2_1',
          speaker: 'Romo Darius',
          text: `Selamat pagi nak, apa yang kamu sedang cari.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "romo_part2_2",
        },
        romo_part2_2: {
          id: 'romo_part2_2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Aku ingin memberi sumbangan ke gereja. ',
              nextDialogId: 'romo_bible_1',
              requirements: {
                requiredItems: [{ itemId: 'coin_gold', quantity: 200 }],
              },
              consumeItems: [
                { itemId: 'coin_gold', quantity: 200 }
              ],
              itemReward: { itemId: 'bible', quantity: 1},
            },
            {
              text: 'Hadiah untuk adik saya',
              nextDialogId: 'romo_part2_3a',
            },
            {
              text: 'Mencari Pencerahan',
              nextDialogId: 'romo_part2_3b',
            },
          ],
        },
        romo_bible_1: {
          id: 'romo_bible_1',
          speaker: 'Romo Darius',
          text: `Terimia kasih atas sumbangan kamu. Gereja sangat membutuhkan ini.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_bible_2',
        },
        romo_bible_2: {
          id: 'romo_bible_1',
          speaker: 'Romo Darius',
          text: `Ijinkan saya memberikan ini atas bentuk terima kasih`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_bible_3',
        },
        romo_bible_3: {
          id: 'romo_bible_1',
          speaker: 'Romo Darius',
          text: `Yan menerima sebuah alkitab!`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_bible_4',
        },
        romo_bible_4: {
          id: 'romo_bible_4',
          speaker: 'Yan',
          text: `Alkitab.... mungkin ini bisa diberikan untuk Diana.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
        romo_part2_3a: {
          id: 'romo_part2_3a',
          speaker: 'Romo Darius',
          text: `Apapun itu yang kamu cari, tidak ada disini.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
        romo_part2_3b: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Ini tempat yang tepat. Ayo kita pejamkan mata dan berdoa.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_part2_4',
        },
        romo_part2_4: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `...`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId: 'romo_part2_5',
        },
        romo_part2_5: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `...`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId: 'romo_part2_6',
        },
        romo_part2_6: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `...`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId: 'romo_part2_7',
        },
        romo_part2_7: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Doa Selesai.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_part2_8',
        },
        romo_part2_8: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Doa Selesai.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Doa apa itu? tidak ada dialognya sama sekali?',
              nextDialogId: 'romo_part2_9',
            },
            {
              text: 'Terima kasih Romo.',
              nextDialogId: 'romo_end',
            },
          ],
        },
        romo_part2_9: {
          id: 'romo_part2_3b',
          speaker: 'Romo Darius',
          text: `Terkadang jawaban dari pertanayan yang di cari ada di diri sendiri.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true,
        },
        romo_end: {
          id: 'romo_end',
          speaker: 'Romo Darius',
          text: `Sama-sama. Kembali lagi jika membutuhkan pencerahan.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd:true
        },
      },
    },
  },
  {
    x: 3050,
    y: 950,
    name: 'Ato',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_ato.png', // Use NPC image
    dialogTree: {
      startDialogId: 'ato_part1_1',
      nodes: {
        ato_part1_1: {
          id: 'ato_part1_1',
          speaker: 'Ato',
          text: `Aku sangat ingin mabuk! Sayangnya, uang ku kurang!`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 3200,
    y: 1050,
    name: 'Penjual',
    color: 0x9932cc, // Dark orchid
    repeatable : true,
    spriteImage: 'assets/sprite/sprite_npc_mom.png', // Use NPC image
    dialogTree: {
      startDialogId: 'penjual_part1_1',
      nodes: {
        penjual_part1_1: {
          id: 'penjual_part1_1',
          speaker: 'Penjual',
          text: `Cap tikus kami terbaik, seharga 200 rupiah saja! Ada yang bisa saya bantu?`,
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId: 'penjual_part1_2',
        },
        penjual_part1_2: {
          text : "",
          id: 'penjual_part1_1',
          speaker: 'Penjual',
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          choices: [
            {
              text: 'Saya hanya ingin melihat-lihat',
              nextDialogId: 'penjual_part1_3',
            },
            {
              text: 'Saya ingin membeli kado untuk gadis kecil. Apakah ada?',
              nextDialogId: 'penjual_part1_3a',
            },
            {
              text: 'Saya ingin membeli cap tikus',
              nextDialogId: 'penjual_part1_a1',
              requirements: {
                requiredItems: [{ itemId: 'coin_gold', quantity: 200 }],
              },
              consumeItems: [
                { itemId: 'coin_gold', quantity: 200 }
              ],
              itemReward: { itemId: 'cap_tikus', quantity: 1},
            },
          ],
        },
        penjual_part1_a1: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Yan memberikan 200 rupiah dan mendapatkan cap tikus!`,
          isEnd : true,
        },
        penjual_part1_3a: {
          id: 'penjual_part1_3',
          speaker: 'Penjual',
          text: `Kami tidak menjual barang seperti itu. Mungkin bisa mencari di toko lain.`,
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId: 'penjual_part1_3',
          isEnd: true
        },
        penjual_part1_3: {
          id: 'penjual_part1_3',
          speaker: 'Penjual',
          text: `Terima kasih, sampai jumpa!`,
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId: 'penjual_part1_2',
          isEnd: true
        },
      },
    },
  },
  {
    x: 2230,
    y: 1650,
    name: 'Sondakh',
    spriteImage: 'assets/sprite/sprite_sondakh.png', // Use NPC image
    dialogTree: {
      startDialogId: 'sondakh_1',
      nodes: {
        sondakh_1: {
          id: 'sondakh_1',
          speaker: 'Sondakh',
          text: `Sepertinya kita kedatangan orang kota semalam.`,
          characterImage: '/assets/character/v2/sondakh.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "sondakh_2",
        },
        sondakh_2: {
          id: 'sondakh_2',
          speaker: 'Sondakh',
          text: `Pagi-pagi saja sudah berisik, menggangu ketenangan warga saja.`,
          characterImage: '/assets/character/v2/sondakh.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "sondakh_3",
        },
        sondakh_3: {
          id: 'sondakh_3',
          speaker: 'Sondakh',
          text: `Mereka tidak mengerti bahwa aku perlu menjaga kencantikan dengan tidur yang cukup setiap hari.`,
          characterImage: '/assets/character/v2/sondakh.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2300,
    y: 1700,
    name: 'Holga',
    spriteImage: 'assets/sprite/sprite_holga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Sondakh',
          text: `Sondakh, anakku, adalah anak paling cantik di seluruh desa.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'holga_2',
          speaker: 'Sondakh',
          text: `Suatu hari dia akan menikah dengan orang kota yang kaya raya!`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2150,
    y: 1155,
    name: 'Anak Kecil',
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    repeatable : true,
    hideOnState : ["BONEKA_GIVEN"],
    dialogTree: {
      startDialogId: 'anak_1',
      nodes: {
        anak_1: {
          id: 'anak_1',
          speaker: 'Yan',
          text: `Anak kecil ini sepertinya sedang menangis`,
          characterImage: '/assets/character/v2/little_girl.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "anak_2",
        },
        anak_2: {
          id: 'anak_2',
          speaker: '',
          text : "",
          characterImage: '/assets/character/v2/little_girl.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          choices: [
            {
              text: 'Berikan boneka ke adik kecil',
              nextDialogId: 'anak_b1',
              requirements: {
                requiredItems: [{ itemId: 'teddy_bear', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'teddy_bear', quantity: 1 }
              ],
            },
            {
              text: 'Kenapa menangis dik?',
              nextDialogId: 'anak_3',
            },
            {
              text: 'Sedang mencari apa dik?',
              nextDialogId: 'anak_3',
            },
          ],
        },
        anak_b1: {
          id: 'anak_3',
          speaker: 'Anak Kecil',
          text: `Wah, terima kasih banyak kak!`,
          characterImage: '/assets/character/v2/little_girl.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "anak_4",
          storyActions : [
              { type: 'addState', value: "BONEKA_GIVEN" },
            { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
          ],
          isEnd : true
        },
        anak_3: {
          id: 'anak_3',
          speaker: 'Anak Kecil',
          text: `Aku sedang mencari boneka ku, entah hilang dimana`,
          characterImage: '/assets/character/v2/little_girl.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "anak_4",
        },
        anak_4: {
          id: 'anak_4',
          speaker: 'Anak Kecil',
          text: `Tolong aku kak!`,
          characterImage: '/assets/character/v2/little_girl.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          isEnd : true,
        },
      },
    },
  },
  {
    x: 3510,
    y: 1720,
    name: 'Informasi',
    spriteImage: 'assets/sprite/nada.png', // Use NPC image
    dialogTree: {
      startDialogId: 'informasi1',
      nodes: {
        informasi1: {
          id: 'informasi1',
          speaker: '',
          text: `Anda memasuki daerah cagar alam Danau XXX`,//TODO danau apa?
          nextDialogId : "kuburan2",
          isEnd : true
        },
      },
    },
  },
];

export default config;
